import React from 'react';
import { AiConfigureMenu } from './AiConfigureMenu';
import { buildAiConfigureItems } from './destinations';
/**
 * AiConfigureReviewHeader
 *
 * Default-exported mount wrapper so the Inspection Assistant Review queue page
 * (`ai_to_review_inspections#index`) can drop the admin-only Configure menu into
 * its ERB header via `react_component 'AiConfigureReviewHeader'` (IP-14857).
 * Renders the shared `AiConfigureMenu` with the review-surface destinations.
 *
 * @version 1.0.0
 * @since 2026-07-20
 */
export default function AiConfigureReviewHeader({ isAdmin = false }) {
    // The review-queue header sits on the purple `workspace__major--listing`
    // hero, so the trigger must use the on-dark Quimby button treatment
    // (qmb-ui-button--dark → white text/icon) to match the prototype. Without
    // mode="dark" the label renders near-black and is invisible on the hero.
    return React.createElement(AiConfigureMenu, { items: buildAiConfigureItems('review'), visible: isAdmin, mode: "dark" });
}
AiConfigureReviewHeader.displayName = 'AiConfigureReviewHeader';
